@if (auction) {
  <form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center justify-between" mat-dialog-title>
      <div>
        @if (isUpdateMode() && canEdit()) {
          <h4 class="text-sm font-light">Editace aukce</h4>
        }
        @if (isUpdateMode() && !canEdit()) {
          <h4 class="text-sm font-light">Náhled aukce</h4>
        }
        @if (isUpdateMode()) {
          <h2 class="flex-auto m-0 headline">
            {{ auction.originalTitle }}
          </h2>
        }
        @if (isCreateMode()) {
          <h2 class="flex-auto m-0 headline">Nová aukce</h2>
        }
      </div>
    </div>

    <mat-divider class="text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
      <div class="flex w-full space-x-4">
        <mat-form-field class="w-2/3">
          <mat-label>Originální název aukce</mat-label>
          <input formControlName="originalTitle" matInput />
          <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
        </mat-form-field>
        <mat-form-field class="w-1/3">
          <mat-label>Jazyk originálního názvu</mat-label>
          <mat-select formControlName="originalTitleLocale">
            @if (
              getLocaleByCode(form.get("originalTitleLocale").value);
              as locale
            ) {
              <mat-select-trigger>
                @if (locale.id !== 99) {
                  <flag type="round" [localeId]="locale.id" class="mr-1"></flag>
                }
                {{ locale.title }}</mat-select-trigger
              >
            }
            @for (locale of availableLocales; track locale) {
              <mat-option value="{{ locale.code }}"
                ><flag type="round" [localeId]="locale.id" class="mr-1"></flag
                >{{ locale.title }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Pořadatel</mat-label>
        <mat-select formControlName="organizerId">
          @for (c of contacts; track c) {
            <mat-option [value]="c.id">{{ c.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Stát konání</mat-label>
        <mat-select formControlName="countryCode">
          @for (country of countries; track country) {
            <mat-option value="{{ country.id }}">{{ country.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Rok konání</mat-label>
        <input formControlName="year" matInput type="number" />
        <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
      </mat-form-field>
      <div class="flex w-full space-x-4">
        <mat-form-field class="w-1/2">
          <mat-label
            ><flag type="round" [localeId]="1" class="mr-1"></flag>Text roku
            konání</mat-label
          >
          <input formControlName="yearCS" matInput />
          <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
        </mat-form-field>
        <mat-form-field class="w-1/2">
          <mat-label
            ><flag type="round" [localeId]="2" class="mr-1"></flag>Year of event
            text</mat-label
          >
          <input formControlName="yearEN" matInput />
          <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
        </mat-form-field>
      </div>
      @if (isEditorContext()) {
        <div class="flex justify-between w-full mb-4">
          <div class="flex items-center space-x-2">
            <mat-label class="font-semibold">Globální</mat-label
            ><mat-icon
              svgIcon="mat:info"
              matTooltip="Určuje, zda je aukce viditelná ve všech soupisech"
            ></mat-icon>
          </div>
          <mat-slide-toggle formControlName="curated"> </mat-slide-toggle>
        </div>
      }
      <mat-tab-group mat-stretch-tabs preserveContent>
        <mat-tab>
          <ng-template matTabLabel
            ><flag type="round" [localeId]="1" class="mr-1"></flag>
            čeština</ng-template
          >
          <ng-template matTabContent>
            <div class="flex flex-col w-full mt-2">
              <mat-form-field>
                <mat-label>Název aukce</mat-label>
                <input formControlName="titleCS" matInput />
                <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Město konání</mat-label>
                <input formControlName="cityNameCS" matInput />
                <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
              </mat-form-field>
              <div class="flex flex-col mb-2">
                <div class="flex items-center -mb-0.5 ml-2">
                  <mat-icon
                    class="mr-2"
                    matPrefix
                    svgIcon="mat:perm_identity"
                  ></mat-icon>
                  <h2 class="font-semibold">Popis aukce</h2>
                </div>
                <div>
                  <editor
                    [init]="tinyService.modulesEasy()"
                    class="w-full"
                    formControlName="descriptionCS"
                  >
                  </editor>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template matTabLabel
            ><flag type="round" [localeId]="2" class="mr-1"></flag>
            english</ng-template
          >
          <ng-template matTabContent>
            <div class="flex flex-col w-full mt-2">
              <mat-form-field>
                <mat-label>Auction title</mat-label>
                <input formControlName="titleEN" matInput />
                <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
              </mat-form-field>
              <mat-form-field>
                <mat-label>City of the event</mat-label>
                <input formControlName="cityNameEN" matInput />
                <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
              </mat-form-field>
              <div class="flex flex-col mb-2">
                <div class="flex items-center -mb-0.5 ml-2">
                  <mat-icon
                    class="mr-2"
                    matPrefix
                    svgIcon="mat:perm_identity"
                  ></mat-icon>
                  <h2 class="font-semibold">Auction Description</h2>
                </div>
                <div>
                  <editor
                    [init]="tinyService.modulesEasy()"
                    class="w-full"
                    formControlName="descriptionEN"
                  >
                  </editor>
                </div>
              </div>
            </div> </ng-template></mat-tab
      ></mat-tab-group>
    </mat-dialog-content>
    <mat-divider class="text-border"></mat-divider>
    @if (canEdit()) {
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">Zrušit</button>
        <button
          color="primary"
          mat-flat-button
          type="submit"
          [disabled]="form.invalid"
        >
          {{ isCreateMode() ? "Vytvořit" : "Aktualizovat" }}
        </button>
      </mat-dialog-actions>
    }
  </form>
}
